import { createLoggerFunc } from '@updater-core/lib/logger';
import { ENVIRONMENT } from '@updater-core/lib/environment';

export const createLogger = createLoggerFunc(
  ENVIRONMENT?.debug?.moveYourStuff,
  '[MOVE_YOUR_STUFF]',
  'color: #70ABAF'
);

export const { log } = createLogger();
